module.exports = __webpack_public_path__ + "static/media/no.fbcb566f.svg";